import { sendRequest } from "../../sendRequest";

export const withdrawOffer = ({ offerId }) => {
  return sendRequest(
    "patch",
    `/influencer/campaign/offer/withdraw/${offerId}`
  ).then((res) => res.data);
};
